import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { WhyPollsFail } from '../components/WhyPollsFail';
import { IntroducingPulseMarkets } from '../components/IntroducingPulseMarkets';
import { CreatorLabProgram } from '../components/CreatorLabProgram';
import { FAQ } from '../components/FAQ';
import { ApplicationModal } from '../components/ApplicationModal';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return <div className="min-h-screen bg-navy-950 text-slate-100 font-sans selection:bg-mint-500/30" data-id="element-266">
      <Navigation onApplyClick={openModal} data-id="element-267" />
      <main data-id="element-268">
        <Hero onApplyClick={openModal} data-id="element-269" />
        <WhyPollsFail data-id="element-270" />
        <IntroducingPulseMarkets data-id="element-271" />
        <CreatorLabProgram onApplyClick={openModal} data-id="element-272" />
        <FAQ data-id="element-273" />
      </main>
      <Footer data-id="element-274" />

      <ApplicationModal isOpen={isModalOpen} onClose={closeModal} data-id="element-275" />
    </div>;
}